import {mapActions, mapState} from 'vuex';
import NavigationMixin from './navigation.mixin';
import {authService, authStorageService} from '../services/service-factory';

export default {
  props: {
    checkAuthInterval: {
      type: Number,
      default: 5000
    }
  },
  mixins: [NavigationMixin],
  data: function () {
    return {
      authService: undefined,
      authCheckTimer: undefined
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      isAdmin: state => state.auth.isAdmin,
      auth: state => state.auth.auth
    })
  },
  methods: {
    ...mapActions({setAuth: 'auth/setAuth', removeAuth: 'auth/removeAuth', setIsAuthenticated: 'auth/setIsAuthenticated', setIsAdmin: 'auth/setIsAdmin'}),
    async checkRouteAuth() {
      if (this.$route.meta.requiresAuth && !this.authStorageService.isAuthenticated()) {
        await this.signOut();
      }
    },
    async signOut() {
      this.setAuth(null);
      await this.authService.signOut();
      this.goToSignInPage();
    }
  },
  created: function () {
    this.authService = authService;
    this.authStorageService = authStorageService;
    const isAuthenticated = this.authStorageService.isAuthenticated();
    if (isAuthenticated) {
      const auth = this.authStorageService.getAuth();
      this.setAuth(auth);
      this.setIsAdmin(auth.role == 'admin');
    }
    this.authCheckTimer = setInterval(this.checkRouteAuth, this.checkAuthInterval);
  },
  beforeDestroy: function () {
    if (this.authCheckTimer) {
      clearInterval(this.authCheckTimer);
      this.authCheckTimer = undefined;
    }
  }
};
